export default "/images/a10be0af4235ed33a2cdc38f1ff5bcbf.avif";